import React from 'react'
import PropTypes from 'prop-types'
import { CustomFormContainer } from './CustomForm'
import { CTA_FORM_NAMES } from 'LiveBoard/components/shared/CallToAction/types/forms/constants'
import { ExternalForm } from './ExternalForm'
import { MarketoFormContainer } from './MarketoForm'
import { EloquaFormContainer } from './EloquaForm'
import FORM_TYPES_CONFIG from 'common/constants/formTypes'

const FORM_TYPES = FORM_TYPES_CONFIG.form_types

const ConfigurableForm = (props) => {
  const renderExternalForm = () =>
    <ExternalForm
      config={props.config}
      onDone={props.onDone} />

  const renderCustomForm = () =>
    <CustomFormContainer
      config={props.config}
      area={props.area}
      itemId={props.itemId}
      ctaClass={props.ctaClass}
      form={props.form || CTA_FORM_NAMES.customForm}
      onSubmit={props.onSubmit} />

  const renderMarketoForm = () =>
    <MarketoFormContainer
      config={props.config}
      area={props.area}
      itemId={props.itemId}
      onSubmit={props.onSubmit} />

  const renderEloquaForm = () =>
    <EloquaFormContainer
      config={props.config}
      area={props.area}
      itemId={props.itemId}
      onDone={props.onDone}
      onSubmit={props.onSubmit}
      themeColorHex={props.themeColorHex} />

  const FORM_ELEMENT = {
    [FORM_TYPES.external]: renderExternalForm(),
    [FORM_TYPES.classic]: renderCustomForm(),
    [FORM_TYPES.marketo]: renderMarketoForm(),
    [FORM_TYPES.eloqua]: renderEloquaForm()
  }

  const form = props.config.form

  return form
    ? FORM_ELEMENT[form.form_type]
    : <></>
}

ConfigurableForm.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  form: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default ConfigurableForm